/**
 * IMPLEMENT-7 / VLO-RICHTIG-FALSCH — rein frontendseitiger Aufbau eines visuellen
 * "Richtig / Falsch"-Lernbausteins AUSSCHLIESSLICH aus bereits vorhandenen D1-Texten
 * der Betriebsanweisung (die der API-Payload ohnehin enthält).
 *
 * Quelle (nur gelesen, verbatim):
 *   - Richtig (grün): betriebsanweisung.protective_measures[]  (Schutzmaßnahmen)
 *   - Falsch  (rot):  betriebsanweisung.main_hazards[]          (Hauptgefahren)
 *
 * KEINE Backend-/D1-/Evidence-/Snapshot-/WORM-/PDF-Berührung. KEINE neuen Fakten,
 * KEINE Negation/Erfindung, KEINE KI, KEINE Szenenerfindung. Fail-closed: gibt es
 * keine verwertbaren Texte, wird null geliefert (der Block entfällt vollständig).
 */
export function buildRichtigFalsch(course) {
  const ba = course?.betriebsanweisung;
  if (!ba || typeof ba !== "object") return null;

  const clean = (arr) =>
    (Array.isArray(arr) ? arr : [])
      .filter((t) => typeof t === "string" && t.trim().length > 0)
      .map((t) => ({ text: t.trim() }));

  const richtig = clean(ba.protective_measures);
  const falsch = clean(ba.main_hazards);

  if (richtig.length === 0 && falsch.length === 0) return null; // fail closed

  return {
    id: "richtig_falsch",
    vlo_type: "richtig_falsch",
    label: "Richtig & Falsch",
    payload: { richtig, falsch },
  };
}
